<template>
	<div class="oidc-test-container">
		<div class="test-box">
			<h1 class="title">OIDC 登录测试</h1>
			
			<div v-if="!isLoggedIn" class="login-section">
				<el-button 
					type="primary" 
					size="large"
					@click="handleLogin"
					:loading="loading"
					class="login-button"
				>
					<i class="el-icon-user"></i>
					<span>OIDC 登录</span>
				</el-button>
			</div>

			<div v-else class="user-info-section">
				<div class="user-header">
					<el-avatar :size="80" :src="userInfo.avatar" class="user-avatar">
						<i class="el-icon-user-solid"></i>
					</el-avatar>
					<h2 class="user-name">{{ userInfo.nickname || '用户' }}</h2>
				</div>

				<div class="info-list">
					<div class="info-item">
						<span class="label">用户昵称：</span>
						<span class="value">{{ userInfo.nickname || '-' }}</span>
					</div>
					<div class="info-item">
						<span class="label">头像地址：</span>
						<span class="value">{{ userInfo.avatar || '-' }}</span>
					</div>
					<div class="info-item">
						<span class="label">公司编号：</span>
						<span class="value">{{ userInfo.oucode || '-' }}</span>
					</div>
					<div class="info-item">
						<span class="label">公司名称：</span>
						<span class="value">{{ userInfo.ouname || '-' }}</span>
					</div>
					<div class="info-item">
						<span class="label">组织类型：</span>
						<span class="value">{{ userInfo.outype || '-' }}</span>
					</div>
				</div>

				<el-button 
					type="danger" 
					@click="handleLogout"
					:loading="logoutLoading"
					class="logout-button"
				>
					<i class="el-icon-switch-button"></i>
					<span>退出登录</span>
				</el-button>
			</div>
		</div>
	</div>
</template>

<script>
import { signinRedirect, signoutRedirect, getUser } from '@/utils/oidcTestConfig'

export default {
	name: 'OidcTest',
	data() {
		return {
			loading: false,
			logoutLoading: false,
			isLoggedIn: false,
			userInfo: {
				nickname: '',
				avatar: '',
				oucode: '',
				ouname: '',
				outype: ''
			}
		}
	},
	async created() {
		await this.checkLoginStatus()
	},
	methods: {
		async checkLoginStatus() {
			try {
				const user = await getUser()
				if (user && !user.expired) {
					this.isLoggedIn = true
					this.extractUserInfo(user)
				}
			} catch (error) {
				console.error('检查登录状态失败:', error)
			}
		},

		extractUserInfo(user) {
			// 从 id_token 中提取用户信息
			// user.profile 包含从 id_token 解析出的用户信息
			const profile = user.profile || {}
			
			// 如果 profile 中没有信息，尝试从 id_token 直接解析
			let idTokenClaims = {}
			if (user.id_token) {
				try {
					// id_token 是 JWT 格式，包含三部分：header.payload.signature
					// 我们只需要解析 payload 部分
					const parts = user.id_token.split('.')
					if (parts.length >= 2) {
						// Base64 解码 payload
						const payload = JSON.parse(atob(parts[1].replace(/-/g, '+').replace(/_/g, '/')))
						idTokenClaims = payload
						console.log('从 id_token 解析的 claims:', payload)
					}
				} catch (e) {
					console.warn('解析 id_token 失败:', e)
				}
			}
			
			// 合并 profile 和 idTokenClaims，idTokenClaims 优先级更高
			const userData = { ...profile, ...idTokenClaims }
			
			this.userInfo = {
				nickname: userData.nickname || userData.name || userData.preferred_username || '',
				avatar: userData.avatar || userData.picture || '',
				oucode: userData.oucode || '',
				ouname: userData.ouname || userData.organization || '',
				outype: userData.outype || ''
			}

			console.log('提取的用户信息:', this.userInfo)
			console.log('完整 profile:', profile)
			console.log('id_token claims:', idTokenClaims)
		},

		async handleLogin() {
			try {
				this.loading = true
				await signinRedirect()
			} catch (error) {
				console.error('登录失败:', error)
				this.$message.error(error.message || '登录失败，请稍后重试')
				this.loading = false
			}
		},

		async handleLogout() {
			try {
				this.logoutLoading = true
				await signoutRedirect()
			} catch (error) {
				console.error('登出失败:', error)
				this.$message.error('登出失败，请重试')
				this.logoutLoading = false
			}
		}
	}
}
</script>

<style lang="scss" scoped>
.oidc-test-container {
	min-height: 100vh;
	display: flex;
	align-items: center;
	justify-content: center;
	background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
	padding: 20px;
}

.test-box {
	background: #fff;
	border-radius: 16px;
	box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
	padding: 50px 40px;
	width: 100%;
	max-width: 600px;
	text-align: center;
}

.title {
	font-size: 32px;
	font-weight: 700;
	color: #333;
	margin: 0 0 40px 0;
	background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
	-webkit-background-clip: text;
	-webkit-text-fill-color: transparent;
	background-clip: text;
}

.login-section {
	padding: 20px 0;
}

.login-button {
	width: 100%;
	height: 50px;
	font-size: 16px;
	font-weight: 600;
	border-radius: 8px;
	background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
	border: none;
	box-shadow: 0 4px 15px rgba(102, 126, 234, 0.4);

	i {
		margin-right: 8px;
		font-size: 18px;
	}
}

.user-info-section {
	text-align: left;
}

.user-header {
	text-align: center;
	margin-bottom: 30px;
	padding-bottom: 30px;
	border-bottom: 1px solid #eee;
}

.user-avatar {
	border: 4px solid #f0f0f0;
	margin-bottom: 15px;
}

.user-name {
	font-size: 24px;
	font-weight: 600;
	color: #333;
	margin: 0;
}

.info-list {
	margin-bottom: 30px;
}

.info-item {
	display: flex;
	padding: 15px 0;
	border-bottom: 1px solid #f0f0f0;

	&:last-child {
		border-bottom: none;
	}
}

.label {
	font-size: 14px;
	color: #666;
	min-width: 100px;
	font-weight: 500;
}

.value {
	font-size: 14px;
	color: #333;
	flex: 1;
	word-break: break-all;
}

.logout-button {
	width: 100%;
	height: 44px;
	font-size: 16px;
	border-radius: 8px;

	i {
		margin-right: 8px;
	}
}

/* 响应式设计 */
@media (max-width: 768px) {
	.test-box {
		padding: 40px 30px;
		margin: 20px;
	}

	.title {
		font-size: 28px;
	}
}
</style>

